var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KImg',{attrs:{"src":require('../common/hummingbird-small-cc-by-sa-4.jpg'),"altText":"A sitting hummingbird","borderRadius":"8px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }